import { useState } from "react";
import CoreValuesCard from "../components/CoreValuesCard";
import WhyUsCard from "../components/WhyUsCard";
import AboutHeaderBackground from "../assets/about_header-1.png";
import AboutHistoryImage from '../assets/about_history.png'
import WhyChooseUs1 from '../assets/WhyChooseUs1.png'
import WhyChooseUs2 from '../assets/WhyChooseUs2.png'
import WhyChooseUs3 from '../assets/WhyChooseUs3.png'
import WhyChooseUs4 from '../assets/WhyChooseUs4.png'
import AboutMission from '../assets/about_mission.png'
import AboutVision from '../assets/about_vision.png'
import PremiumQuality from '../assets/premium_quality-achievement.png'
import QualityProduct from '../assets/quality_product-achievement.png'
import TopQuality from '../assets/top_quality-achievement.png'
import AchievementCard from "../components/AchievementCard";
import "../styles/AboutHeader.css";
import "../styles/AboutHistory.css";
import "../styles/CoreValues.css";
import "../styles/WhyChooseUs.css";
import "../styles/AboutMissionVision.css";
import "../styles/Achievement.css";

const AboutPage = () => {
    const [selectedButton, setSelectedButton] = useState('History');
    const articleText = {
        'History': `<p classname="about_history-article-text">
            History: Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum 
            is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the 
            industry’s standard dummy text ever since the 1500s, when an unknown printer took a Lorem 
            Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer 
            took a
            </p> <p classname="about_history-article-text">
            History: Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum 
            is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the 
            industry’s standard dummy text ever since the 1500s, when an unknown printer took a Lorem 
            Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer 
            took a
            </p>`,
        'Our Philosophy': `<p classname="about_history-article-text">
            Our Philosophy: Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum 
            is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the 
            industry’s standard dummy text ever since the 1500s, when an unknown printer took a Lorem 
            Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer 
            took a
            </p> <p classname="about_history-article-text">
            Our Philosophy: Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum 
            is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the 
            industry’s standard dummy text ever since the 1500s, when an unknown printer took a Lorem 
            Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer 
            took a
            </p>`,
        'Our Founders': `<p classname="about_history-article-text">
            Our Founders: Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum 
            is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the 
            industry’s standard dummy text ever since the 1500s, when an unknown printer took a Lorem 
            Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer 
            took a
            </p> <p classname="about_history-article-text">
            Our Founders: Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum 
            is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the 
            industry’s standard dummy text ever since the 1500s, when an unknown printer took a Lorem 
            Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer 
            took a
            </p>`
    };

    const coreValuesCards = [
        {
            title: 'Engagement', text: `Harnessing our experience with regulators and industry bodies, we offer 
            advice from the inside out. We remain at the forefront of industry news and practices to provide relevant
            advice and impactful strategies.`},
        {
            title: 'Collaboration', text: `A multi-disciplinary approach enables our sharp legal knowledge to be 
        delivered through a commercial lens. Our lawyers and consultants collaborate with our clients to sustainably 
        scale their future operations.`},
        {
            title: 'Agility', text: `Our ability to think and act quickly is why our clients choose to keep us in their 
        corner. We’re always thinking ahead to avoid future issues. If inevitable problems arise – we know how to tackle 
        them head on.` },
    ];

    const whyChooseUsCards = [
        {
            url: WhyChooseUs1, title: 'Client-Centric. Always', text: `We put you first, striving to do the best job possible 
                and then some. We’re always approachable, always accessible, and flexible in how we work with you.` },
        {
            url: WhyChooseUs2, title: 'Focused Expertise', text: `We are not a general service law firm, nor a jack of all 
                trades. Instead, we are specialists in our discrete area of law, solving regulatory and compliance issues.` },
        {
            url: WhyChooseUs3, title: 'No-NonSense Problem Solvers', text: `We understand your time is valuable. So we cut 
                through the ‘BS’ and call it how we see it. You can expect an honest, upfront approach and decisive strategies.`
        },
        {
            url: WhyChooseUs4, title: 'A ‘whole of matter’ approach.', text: `Legal problems often requires more than just 
                legal solutions. We provide ‘bigger picture’ strategies which combine legal, business and industry expertise.`
        },
    ]

    const achievements = [
        { url: PremiumQuality, title: 'Lorem Ipsum', text: 'Lorem Ipsum is simply' },
        { url: QualityProduct, title: 'Lorem Ipsum', text: 'Lorem Ipsum is simply' },
        { url: TopQuality, title: 'Lorem Ipsum', text: 'Lorem Ipsum is simply' }
    ]

    return (
        <div className="about">
            <header>
                <div className="about_header-image-wrapper">
                    <img src={AboutHeaderBackground} alt="" className="about_header-image" />
                    <div className="about_header-image-gradient" />
                    <div className="row">
                        <div className="about_header-content">
                            <h1 className="about_header-title">About Us</h1>
                            <p className="about_header-para">
                                Lorem Ipsum is simply dummy text of the printing and typesetting
                                industry.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="about_info-wrapper">
                        <h1 className="about_info-title">Who We Are</h1>
                        <p className="about_info-para">
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                            Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s,
                            when an unknown printer took aLorem Ipsum is simply dummy text of the
                            printing and typesetting industry. Lorem Ipsum is simply dummy text of the
                            printing and typesetting industry.Lorem Ipsum is simply dummy text of the
                            printing and typesetting industry. Lorem Ipsum has been the industry’s standard
                            dummy text ever since the 1500s, when an unknown printer took a
                        </p>
                    </div>
                </div>
            </header>
            <main>
                <section className="about_history">
                    <div className="about_history-titles">
                        <h1 className="about_history-title">Firm History</h1>
                        <h3 className="about_history-subtitle">Lorem Ipsum is simply text text of the printing and typesetting industry.</h3>
                    </div>
                    <figure className="about_history-image-wrapper">
                        <img src={AboutHistoryImage} alt="" className="about_history-image" />
                    </figure>
                    <div className="about_history-content">
                        <h2 className="about_history-content-title">60 Years <span>of legacy</span></h2>
                        <p className="about_history-content-para">You can count on the undivided attention
                            of a team that prizes relationships over profits.</p>
                    </div>
                    <div className="row">
                        <article className="about_history-article">
                            <div className="article_buttons-wrapper">
                                <button className={`about_history-article-button ${selectedButton === "History" && 'article_button-active'}`} onClick={() => setSelectedButton('History')}>History</button>
                                <button className={`about_history-article-button ${selectedButton === "Our Philosophy" && 'article_button-active'}`} onClick={() => setSelectedButton('Our Philosophy')}>Our Philosophy</button>
                                <button className={`about_history-article-button ${selectedButton === "Our Founders" && 'article_button-active'}`} onClick={() => setSelectedButton('Our Founders')}>Our Founders</button>
                            </div>
                            <div className="about_history-article-text-wrapper" dangerouslySetInnerHTML={{ __html: articleText[selectedButton] }}></div>
                        </article>
                    </div>
                </section>
                <section className="core_values">
                    <div className="row">
                        <div className="core_values-titles">
                            <h1 className="core_values-title">Our Core Values</h1>
                            <h3 className="core_values-subtitle">Lorem Ipsum is simply dummy text of the printing and typesetting industry</h3>
                        </div>
                        <div className="core_values-cards">
                            {
                                coreValuesCards.map((coreValueCard, index) => {
                                    return (
                                        <CoreValuesCard coreValueCard={coreValueCard} key={index} />
                                    )
                                })
                            }
                        </div>
                    </div>
                </section>
                <section className="why_us">
                    <div className="row">
                        <div className="why_us-titles">
                            <h1 className="why_us-title">Why Choose Us</h1>
                            <h3 className="why_us-subtitle">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</h3>
                        </div>
                        <div className="why_us-cards">
                            {
                                whyChooseUsCards.map((whyChooseUsCard, index) => {
                                    return (
                                        <WhyUsCard whyChooseUsCard={whyChooseUsCard} key={index} />
                                    )
                                })
                            }
                        </div>
                    </div>
                </section>
                <section className="about_mission-vision">
                    <div className="row">
                        <div className="about_mission">
                            <div className="about_mission-content">
                                <h1 className="about_mission-title">Mission</h1>
                                <p className="about_mission-para">Lorem Ipsum is simply dummy text of the printing
                                    and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting
                                    industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                                    Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown
                                    printer took a galley of type and scrambled it to</p>
                            </div>
                            <img src={AboutMission} alt="" className="about_mission-img" />
                        </div>
                        <div className="about_vision">
                            <img src={AboutVision} alt="" className="about_vision-img" />
                            <div className="about_vision-content">
                                <h1 className="about_vision-title">Vision</h1>
                                <p className="about_vision-para">Lorem Ipsum is simply dummy text of the printing
                                    and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting
                                    industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                                    Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown
                                    printer took a galley of type and scrambled it to</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="about_achievements">
                    <div className="row">
                        <div className="about_achievements-titles">
                            <h1 className="about_achievements-title">Our Achievements</h1>
                            <h3 className="about_achievements-subtitle">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</h3>
                        </div>
                        <div className="achievements_cards">
                            {
                                achievements.map((achievement, index) => {
                                    return (
                                        <AchievementCard achievement={achievement} key={index} />
                                    )
                                })
                            }
                        </div>
                    </div>
                </section>
            </main>
        </div >
    );
};

export default AboutPage;
